import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable} from 'rxjs';

@Injectable()
export class CommonService {
  basePath:string;
  constructor(private http: HttpClient) {
    const hostName = window.location.hostname;
    if (hostName.indexOf("uatwater.ny.gov") != -1){
      this.basePath = "https://uatwater.ny.gov/doh7/waterqual/services/";
    }
    else if (hostName.indexOf("evalwater.ny.gov") != -1) {
       this.basePath = "https://evalwater.ny.gov/doh7/waterqual/services/"
    }
    else if (hostName.indexOf("devwater.ny.gov") != -1) {
      this.basePath = "https://devwater.ny.gov/doh7/waterqual/services/"
    }
    else if (hostName.indexOf("water.ny.gov") != -1) {
      this.basePath = "https://water.ny.gov/doh7/waterqual/services/"
    }
    else {
      //this.basePath = "https://devsgw.health.state.ny.us/doh2/applinks/waterqual/services/rest/";  // for DEV and local machines
      this.basePath = "http://localhost:8081/doh7/waterqual/services/";  // testing
    }
  }

  getAddresses(keyword:string): Observable<any>{
    return this.http.jsonp('https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer/suggest?text='+keyword+'&maxSuggestions=10&countryCode=USA&searchExtent=-79.79,40.1,-71.7,45.5&category=Address,Postal,POI,Populated Place&f=pjson','callback');
  }

  getLngLatForAddress(addrText:string, magicKeyVal:string): Observable<any>{
    var address:any;
    if (magicKeyVal)
      address = this.http.jsonp('https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer/findAddressCandidates?singleLine='+addrText+'&magicKey='+magicKeyVal+'&f=pjson','callback');
    else
      address = this.http.jsonp('https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer/findAddressCandidates?singleLine='+addrText+'&countryCode=USA&searchExtent=-79.79,40.1,-71.7,45.5&category=Address,Postal&f=pjson','callback');
    return address;
  }

  getReverseGeocode(latitude:number, longitude:number): Observable<any>{
    var address:any;
    if (latitude && longitude){  //&outSR=4326
      //console.log(8888888,555, latitude, longitude)
        address = this.http.jsonp('https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer/reverseGeocode?f=pjson&location='+longitude+','+latitude,'callback');
    }
    return address;
  }

  getCountyMaps(): Observable<any>{
    return this.http.get('assets/County_OddFips_GeoJson.json');
  }

  getPWSBoundaryMaps1(): Observable<any>{
    return this.http.get('assets/PWS_GeoJson1.json');
  }
  getPWSBoundaryMaps2(): Observable<any>{
    return this.http.get('assets/PWS_GeoJson2.json');
  }
  getPWSBoundaryMaps3(): Observable<any>{
    return this.http.get('assets/PWS_GeoJson3.json');
  }

  getDOHMapPWS(latitude:number, longitude:number): Observable<any>{
    return this.http.get(this.basePath + 'geocodemiles?latitude='+latitude+'&longitude='+longitude);
  }
  getDOHMapPWSByWSysID(wsysId:number, miles:number): Observable<any>{
    return this.http.get(this.basePath + 'geocodemiles/wsysid?wsysId='+wsysId+'&mileRange='+miles);
  }
  getDOHMapPWSByPwsID(pwsId:string, miles:number): Observable<any>{
    return this.http.get(this.basePath + 'geocodemiles/pwsid?pwsId='+pwsId+'&mileRange='+miles);
  }
  getDOHContaminants(wsysId:number): Observable<any>{
    return this.http.get(this.basePath + 'contaminants?wsysId='+wsysId);
  }
  getDOHViolations(wsysId:number): Observable<any>{
    return this.http.get(this.basePath + 'violations?wsysId='+wsysId);
  }
  getDOHContacts(wsysId:number): Observable<any>{
    return this.http.get(this.basePath + 'adminaddress?wsysId='+wsysId);
  }

  getAnnualRepMetaData(pwsId:string): Observable<any>{
    return this.http.get(this.basePath + 'awqrinfo?pwsId='+pwsId);
  }

  getAnnualRepMetaDataByYr(year:number): Observable<any>{
    return this.http.get(this.basePath + 'awqrinfo?year='+year);
  }
  getAnnualRepPDF(guIds:string): Observable<any>{
    return this.http.get(this.basePath + 'awqrfile?guids='+guIds, { responseType: 'arraybuffer'});
  }
}
